import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import Select from "react-select";
import { Dropdown } from "react-bootstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Table from "@mui/material/Table";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";

// import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
// import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
//** Import Image */
import food1 from "./../../../../images/foods/food1.jpg";
import food2 from "./../../../../images/foods/food2.jpg";
import food4 from "./../../../../images/foods/food4.jpg";
import food9 from "./../../../../images/foods/food9.png";
import food10 from "./../../../../images/foods/food10.jpg";
import food25 from "./../../../../images/foods/food25.jpg";
// import Stepper from "@material-ui/core/Stepper";
// import Step from "@material-ui/core/Step";
// import StepLabel from "@material-ui/core/Step";
// import StepButton from "@material-ui/core/StepButton";
import Typography from "@material-ui/core/Typography";
import FoodMenuForm from "./FoodMenuForm";
import VariantItemForm from "./VariantItemForm";
import AddOnForm from "./AddOnForm";
import { Accordion } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import {
  GetOutletTimingList,
  MenuList,
  saveofMenuAVL,
  saveslotmaster,
  deleteodmenuAVL,
  updateslotmaster,
  getMenuAvailalbitListApi,
  saveoutletDetails,
  getRoleMaster,
  getoutletListMaster,
  addOutletItem,
  UpdateOutletItem,
  gettstaffListMaster,
  getMenuMasterList,
  saveMainMenuName,
  updatePWDstaffDetails,
  saveSubMenuName,
  UomList,
  deletemenuitem,
  getCompanyListMaster,
  getresbasedmenumaster,
  subscriptionPlanId,
  getresbasedPopularMenumaster,
} from "../../../../apiservicescall/api";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
import {
  // Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
} from "react-bootstrap";
import { CardTitle, CardBody } from "reactstrap";
import Multiselect from "multiselect-react-dropdown";
import SelectSearch, { fuzzySearch } from "react-select-search";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import { set } from "date-fns";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#00b53b",
  },
  rootExpanded: { flexGrow: 1, width: "100%" },
}));

const OutletFoodMenuListManagment = (props) => {
  const listItem = ["Breakfast", "Lunch", "Dinner", "Dosas"];
  const [menuFoodItemModal, setMenuFoodItemModal] = useState(false);
  const [subscribeItemModalm, setSubscribeItemModal] = useState(false);
  const [subMenuModal, setSubMenuModal] = useState(false);
  const [mainMenuModal, setMainMenuModal] = useState(false);
  const [foodItemTiming, setFoodItemTiming] = useState(false);
  const [errors, setErrors] = useState({
    itemName: null,
    itemPrice: null,
    itemQuantity: null,
    itemDesc: null,
    itemfamily: null,
    uom: null,
    planId: null,
    itemType: null,
    topRecommendation: null,
  });
  const [formIsValid, setFormIsValid] = useState(false);
  const [checkeditem, setCheckeditem] = useState(false);
  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [tempModalPopupValue, setTempModalPopupValue] = useState();
  const [openImagePopup, setOpenImagePopup] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());
  const [category, setCategory] = useState([]);
  const [variant, setVariant] = useState([
    { label: "Size", value: "Size" },
    { label: "Quantity", value: "Quantity" },
    { label: "Rice", value: "Rice" },
  ]);
  const [typeadd, setTypeadd] = useState([
    { label: "Extras", value: "Extras" },
    { label: "Toppings", value: "Toppings" },
    { label: "Scoope", value: "Scoope" },
  ]);
  const [selected, setSelected] = useState([]);
  const [deletepopup, setDeletepopup] = useState(false);
  const [menuMasterList, setMenuMasterList] = useState([]);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );
  const [additemSubmenuMaster, setAdditemSubmenuMaster] = useState([]);
  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  //const [recommendoption, setRecommendOption] = useState(false);

  const [menuSubmenuItems, setMenuSubmenuItems] = useState({
    status: "A",
    menuId: "",
    menuName: "",
    subMenuId: "",
    subMenuName: "",
    selectedMainmenuItem: "",
    selectedSubmenuItem: "",

    selectedMainmenuItemValue: "",
    selectedSubmenuItemValue: "",

    selectedIndividualFoodItem: "",
    selectedIndividualFoodItemName: "",

    startTime: "",
    endTime: "",
    itemDesc: "",
    planId: "",
    itemName: "",
    itemPrice: "",
    itemQuantity: "",
    itemType: false,
    itemFoodImage: "",
    itemFoodPath: "",
    varient: "",
    itemId: "",
    status: "",
  });

  // const columns = [
  //   { header: "Item Name", key: "itemName" },
  //   { header: "Item Price", key: "itemPrice" },
  //   { header: "Item Type", key: "itemType" },
  //   { header: "Item Qty", key: "itemQuantity" },
  //   { header: "Uom Name", key: "uomName" },
  //   { header: "Item Tag", key: "itemTag" },
  //   { header: "Item Detail", key: "itemDesc" },
  //   { header: "planId", key: "planId" },
  // ];
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const workSheetName = "Menu List";
  const workBookName = "Menu List";
  const myInputId = "myInput";
  const workbook = new Excel.Workbook();
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const rootClass = expanded ? classes.rootExpanded : classes.root;
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [admintomanger, setAdmintomanger] = useState(
    JSON.parse(localStorage.getItem("admintomanger"))
  );

  const [timingslist, setTimingslist] = useState([]);
  const [menuAvailablityMaster, setMenuAvailablityMaster] = useState([]);
  const [togglemodal, setTogglemodal] = useState(false);

  const [submenu, setSubmenu] = useState([
    { label: "Dosa varieties", value: "Dosa varieties" },
    { label: "Idly varieties", value: "Idly varieties" },
  ]);

  const [menu, setMenu] = useState([
    { label: "Breakfast", value: "Breakfast" },
    { label: "Lunch", value: "Lunch +" },
  ]);

  const [
    menuAvailablityListSaveUpdateDeleteMaster,
    setMenuAvailablityListSaveUpdateDeleteMaster,
  ] = useState([
    {
      dayId: "1",
      dayName: "Monday",
      dayStatus: "true",
    },
    {
      dayId: "2",
      dayName: "Tuesday",
      dayStatus: "true",
    },
    {
      dayId: "3",
      dayName: "Wednesday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "4",
      dayName: "Thursday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "5",
      dayName: "Friday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "6",
      dayName: "Saturday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "7",
      dayName: "Sunday",
      dayStatus: "true",
      // slotId: []
    },
  ]);

  const [dropdownMaster, setDropdownMaster] = useState([
    { label: "All Day", value: "1" },
    { label: "Day Slot", value: "2" },
  ]);

  const [dropdownMasterDay, setDropdownMasterDay] = useState([
    { label: "Monday", value: "1" },
    { label: "Tuesday", value: "2" },
    { label: "Wednesday", value: "3" },
    { label: "Thursday", value: "4" },
    { label: "Friday", value: "5" },
    { label: "Saturday", value: "6" },
    { label: "Sunday", value: "7" },
  ]);

  const [menulistmaster, setMenulistmaster] = useState([]);
  const [menufetchitem, setMenufetchitem] = useState([
    // {
    //   outletCode: userDetails?.outletCode,
    //   itemId: "",
    //   itemName: "",
    //   itemPrice: "",
    //   itemQuantity: "",
    //   itemDesc: "",
    //   itemType: "",
    //   itemFoodImage: "",
    //   itemImagePath: "",
    //   uomName: "",
    //   itemTag: "",
    //   compCode: userDetails?.compCode    },
  ]);

  const [uomlist, setUomlist] = useState([
    {
      uomId: "",
      uomDescription: "",
      status: "",
    },
  ]);
  const [uomcategory, setUomcategory] = useState([]);

  const [selecteduomMaster, setSelecteduomMaster] = useState({
    label: "",
    value: "",
  });
  ///////
  const [subPlanId, setSubPlanId] = useState([]);
  const [selectedplanId, setSelectedplanId] = useState({
    label: "",
    value: "",
  });

  const [menulistitem, setMenulistitem] = useState([
    {
      compCode: userDetails,
      itemDesc: "",
      itemFoodImage: "",
      itemImagePath: "",
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      itemType: true,
      itemTag: "",
      outletCode: userDetails,
      status: "",
      uom: "",
      planId: "",
      planName: "",
      varient: [
        {
          varientType: "",
          small: "",
          medium: "",
          large: "",
        },
      ],
      outletfoodtype: "",
      topRecommendation: false,
    },
  ]);

  const [dropdownslotmaster, setDropdownslotmaster] = useState([]);
  const [dropdownMastervalue, setDropdownMastervalue] = useState({
    label: "",
    name: "",
  });

  const [companyMaster, setCompanyMaster] = useState([]);
  const [outletvalue, setOutletvalue] = useState([{ label: "", value: "" }]);
  const [restarantvalue, setRestarantvalue] = useState([
    { label: "", value: "", restaurantId: "" },
  ]);
  const [outletMasterlist, setOutletMasterlist] = useState([]);
  const [outletResturantlist, setOutletResturantlist] = useState([]);
  const admintomangerjson = admintomanger && admintomanger.split("-");
  const adminToMangerOutletName =
    admintomangerjson && admintomangerjson[0].trim();
  const adminToMangerOutletCode =
    admintomangerjson && admintomangerjson[1].trim();
  const adminToMangerCompanyCode =
    admintomangerjson && admintomangerjson[2].trim();

  const [specialmenulist, setSpecialMenu] = useState([]);
  const [selectedspecialMenu, setSelectedSpecialMenu] = useState([
    { label: "", value: "" },
  ]);

  const [popularmenu, setPopularMenu] = useState([]);
  const [selectedPopularMenu, setSelectedPopularMenu] = useState([
    { label: "", value: "" },
  ]);

  useEffect(() => {
    getMenuMasterListMasterApi();
    let outletCode =
      adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    getoutlettimeList(outletCode);
    // getmenulist(compCode, outletCode);
    getuomlist();
    getcompanyMasterList();

    //getRestarantmenulist();
    // getoutletList(compCode);
  }, []);

  const saveExcel = async () => {
    try {
      const myInput = document.getElementById(myInputId);
      const fileName = workBookName;

      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);

      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;

      // updated the font for first row.
      worksheet.getRow(1).font = { bold: true };

      // loop through all of the columns and set the alignment with width.
      worksheet.columns.forEach((column) => {
        column.width = column.header.length + 5;
        column.alignment = { horizontal: "center" };
      });

      // loop through data and add each one to worksheet
      menufetchitem.forEach((singleData) => {
        worksheet.addRow(singleData);
      });

      // loop through all of the rows and set the outline style.
      worksheet.eachRow({ includeEmpty: false }, (row) => {
        // store each cell to currentCell
        const currentCell = row._cells;

        // loop through currentCell to apply border only for the non-empty cell of excel
        currentCell.forEach((singleCell) => {
          // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
          const cellAddress = singleCell._address;

          // apply border
          worksheet.getCell(cellAddress).border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });

      // write the content using writeBuffer
      const buf = await workbook.xlsx.writeBuffer();

      // download the processed file
      saveAs(new Blob([buf]), `${fileName}.xlsx`);
    } catch (error) {
      // console.error("<<<ERRROR>>>", error);
      // console.error("Something Went Wrong", error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };

  // useCallback
  const getcompanyMasterList = useCallback(async () => {
    let getoutletList = await getCompanyListMaster();
    let getoutletListValue = getoutletList?.data?.data;
    //console.log("getoutletListValue", getoutletListValue);
    let companyoutmaster =
      getoutletListValue &&
      getoutletListValue.map(({ compCode, compName }) => ({
        label: compName,
        value: compCode,
      }));
    setCompanyMaster(companyoutmaster);
    setOutletvalue({
      label: getoutletListValue[0]?.compName,
      value: getoutletListValue[0]?.compCode,
    });
    getoutletMasterList(getoutletListValue[0]?.compCode);
  }, []);

  const getmenulist = async (compCode, outletCode) => {
    let getslotList = await MenuList(compCode, outletCode);
    let getslotListValue = getslotList?.data?.data;

    console.log("getslotListValue",getslotListValue);
    setMenufetchitem(getslotListValue);
    setMenulistmaster(getslotListValue);
    let searchfieldvalue = "dd";
    let filteredMenuItemList =
      getslotListValue &&
      getslotListValue.filter(
        (item) =>
          item.itemDesc.substring(0, 1) == searchfieldvalue.substring(0, 1)
      );
  };

  const getoutletMasterList = async (companyCode) => {
    let getoutletList = await getoutletListMaster(companyCode);
    let getoutletListValue = getoutletList?.data?.data;
    //console.log("getoutletListValue", getoutletListValue);
    //setOutletResturantlist(getoutletListValue);

    let companyoutmaster =
      getoutletListValue &&
      getoutletListValue.map(({ outletCode, outletName, restaurantId }) => ({
        label: `${outletCode}-${outletName}`,
        value: outletCode,
        restaurantId: restaurantId,
      }));
    // console.log("companyoutmaster", companyoutmaster);
    setOutletMasterlist(companyoutmaster);
  };

  const getRestarantmenulist = async (event) => {
    //let restaurant = outletResturantlist.restaurantId;
    // console.log("outletResturantlist",outletResturantlist?.restaurantId);
    let restaurantId = event.restaurantId;
    // console.log("restaurantId", restaurantId);
    let getresmenuid = await getresbasedmenumaster(restaurantId);
    let getresmenu = getresmenuid.data.data || [];

    // console.log("getresmenu getresmenu", getresmenu);

    let specialmenulist = getresmenu.map(({ id, name, price }) => ({
      // label: `${name}-  Rs. ${price}`,
      label: `${name}`,
      value: `${id}-${name}-${price}`,
    }));
    setSpecialMenu(specialmenulist);
  };

  //search list filter function //
  const searchFilterMenuListMaster = async (value) => {
    if (value == "") {
      let outletCode =
        adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
      let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
      let getslotList = await MenuList(compCode, outletCode);
      let getslotListValue = getslotList?.data?.data;
      setMenufetchitem(getslotListValue);
    } else if (value && value.length >= 1) {
      let outletCode =
        adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
      let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
      let getslotList = await MenuList(compCode, outletCode);
      let getslotListValue = getslotList?.data?.data;
      let valulength = value && value.length;
      let filteredMenuItemList =
        getslotListValue &&
        getslotListValue.filter((item) =>
          // (item.itemTag.substring(0, valulength) ||
          // (item.itemName.substring(0, valulength)) == value.substring(0, valulength)
          item.itemName.includes(value)
            ? value
            : "" || item.itemTag.includes(value)
            ? value
            : ""
        );

      // let strinincludesfilteredMenuItemList = getslotListValue && getslotListValue.filter(
      //   (item) => (item.itemTag.includes(value)) ? value : ""
      // );
      // console.log("filteredMenuItemList", filteredMenuItemList);
      // let searchfieldvalue = "dd";
      // let filteredMenuItemList = getslotListValue && getslotListValue.filter((item) => item.itemDesc.substring(0, 1) == value.substring(0, 1))
      //   .map((items) => ({ items }));
      // console.log("filteredMenuItemList", filteredMenuItemList);
      setMenufetchitem(filteredMenuItemList);
    }
  };

  const getoutletList = async () => {
    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    let getoutletList = await getoutletListMaster(compCode);
    let getoutletListValue = getoutletList?.data?.data;
    // console.log("getoutletListValue78889", getoutletListValue);
    let Outcode =
      adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;
    let tempstatemaster =
      getoutletListValue &&
      getoutletListValue
        .filter((item) => item.outletCode == Outcode)
        .map((items) => ({ items }));
    let checkItemVegTypefromOutletChe =
      tempstatemaster[0] &&
      tempstatemaster[0]?.items?.outletFoodType == "veg,nong-veg"
        ? "veg,nong-veg"
        : "veg";

    setMenulistitem({
      itemDesc: "",
      itemFoodImage: "",
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      itemType: true,
      planId: "",
      planName: "",
      outletfoodtype: checkItemVegTypefromOutletChe,
    });

    getMenuMasterListMasterApi();
    setSelecteduomMaster({});
    setActiveStep(0);
    setErrors({});
    setMenuFoodItemModal(!menuFoodItemModal);
    setSubscribeItemModal(false);
    setIsview(false);
    setIsedit(false);
    // console.log("menuFoodItemModal", menuFoodItemModal);
  };

  const getSubscriptionList = async () => {
    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    let getoutletList = await getoutletListMaster(compCode);
    let getoutletListValue = getoutletList?.data?.data;
    // console.log("getoutletListValue78889", getoutletListValue);
    let Outcode =
      adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;
    let tempstatemaster =
      getoutletListValue &&
      getoutletListValue
        .filter((item) => item.outletCode == Outcode)
        .map((items) => ({ items }));
    let checkItemVegTypefromOutletChe =
      tempstatemaster[0] &&
      tempstatemaster[0]?.items?.outletFoodType == "veg,nong-veg"
        ? "veg,nong-veg"
        : "veg";

    setMenulistitem({
      itemDesc: "",
      itemFoodImage: "",
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      itemType: true,
      planId: "",
      planName: "",
      outletfoodtype: checkItemVegTypefromOutletChe,
    });

    getMenuMasterListMasterApi();
    setSelecteduomMaster({});
    setActiveStep(0);
    setErrors({});
    setMenuFoodItemModal(!menuFoodItemModal);
    setSubscribeItemModal(true);
    setIsview(false);
    setIsedit(false);
    // console.log("menuFoodItemModal", menuFoodItemModal);
  };

  const getRestarantPopularlist = async (e) => {
    let restaurantId = e;

    let getresmenuid = await getresbasedPopularMenumaster(restaurantId);
    //console.log("getresmenuid", getresmenuid);

    let getresmenu = getresmenuid.data.data || [];

    //console.log("getresmenu getresmenu", getresmenu);

    let specialmenulist = getresmenu.map(({ id, name, price }) => ({
      label: name,
      value: `${id}- ${name}-${price} `,
    }));
    setPopularMenu(specialmenulist);
  };

  const getoutlettimeList = async (outletCode) => {
    let getoutletList = await GetOutletTimingList(outletCode);
    let getoutletListValue = getoutletList?.data?.data;
    setTimingslist(getoutletListValue);
    // console.log("getoutletListValue", getoutletListValue);
  };

  //subscription data
  const getSubscrptionList = async (outletCode) => {
    let getplanList = await subscriptionPlanId(outletCode);
    // console.log("getplanList",getplanList);
    let getplanidValue = getplanList.data.data || [];
    //console.log("getplanidValue",getplanidValue);
    setSubPlanId(getplanidValue);
    let Selectedplan = getplanidValue.map(({ planId, planName }) => ({
      label: `${planName}`,
      value: `${planId} - ${planName}`,
    }));
    setSelectedplanId(Selectedplan);

    // console.log("getoutletListValue", getoutletListValue);
  };

  //master data//
  const getuomlist = async () => {
    let getuomList = await UomList();
    let getuomListValue = getuomList?.data?.data || [];
    let outmaster =
      getuomListValue &&
      getuomListValue.map(({ status, uomDescription, uomId }) => ({
        label: uomDescription,
        value: uomId,
      }));
    setUomlist(getuomListValue);
    setUomcategory(outmaster);
    // console.log("outmaster", outmaster);
    // console.log("getuomListValue", getuomListValue);
  };

  const getMenuMasterListMasterApi = async () => {
    menumasterlabelvalue();
    setMenuSubmenuItems({
      menuId: menuSubmenuItems?.menuId,
      menuName: menuSubmenuItems?.menuName,
      selectedSubmenuItem: menuSubmenuItems?.selectedSubmenuItem,
      selectedSubmenuItemValue: menuSubmenuItems?.selectedSubmenuItemValue,
      subMenuId: menuSubmenuItems?.subMenuId,
      selectedMainmenuItem: menuSubmenuItems?.selectedMainmenuItem,
      selectedMainmenuItemValue: menuSubmenuItems?.menuId,
    });
  };

  const menumasterlabelvalue = () => {
    let outmaster =
      menuMasterList &&
      menuMasterList.map(({ menuId, menuName }) => ({
        label: menuName,
        value: menuId,
      }));
    setCategory(outmaster);
  };

  const dropdownHandling = async (type, event) => {
    // if (event?.value == "2") {
    //   setDropdownMasterDay([])
    // }
    setDropdownMastervalue(event);
    //console.log("dropdownMastervalue", dropdownMastervalue);
    // const [dropdownMastervalue, ] = useState({ label: "", name: "" });
  };

  const onToggleClose = () => {
    setTogglemodal(!togglemodal);
  };

  const itemtoggle = async (items) => {
   
    console.log("items", items);
    const str = [items?.itemTag];

    const result = str.toString().split(",");

    setSelected(result);
    let compCode = outletvalue.value;
    let getoutletList = await getoutletListMaster(compCode);
    let getoutletListValue = getoutletList?.data?.data || [];
    let Outcode = restarantvalue.value;
    let tempstatemaster =
      getoutletListValue &&
      getoutletListValue
        .filter((item) => item.outletCode == Outcode)
        .map((items) => ({ items }));
    let checkItemVegTypefromOutletChe =
      tempstatemaster[0] &&
      tempstatemaster[0]?.items?.outletFoodType == "veg,nong-veg"
        ? "veg,nong-veg"
        : "veg";

    let itemNamechng = {
      label: items?.itemName,
      value: `${items?.itemId - items?.itemName}`,
    };

     console.log("itemNamechng", itemNamechng);

    setMenulistitem({
      itemDesc: items?.itemDesc,
      itemFoodImage: items?.itemFoodImage,
      itemImagePath: items?.itemImagePath,
      itemId: items?.itemId || "",
      itemName: itemNamechng,
      itemPrice: items?.itemPrice,
      itemTag: items?.itemTag,
      itemQuantity: items?.itemQuantity,
      itemType: items?.itemType === "veg" ? true : false,
      outletfoodtype: checkItemVegTypefromOutletChe,
      outletCode: restarantvalue.value,
      status: "A",
      uom: items?.uom,
      uomName: items?.uomName,
      topRecommendation: items?.topRecommendation,
    });

    getuomlist();
    setSelecteduomMaster({
      label: items?.uomName,
      value: items?.uom,
    });

    setSelectedSpecialMenu
     ( {
        label: items?.itemName,
        value: items?.itemName,
      });
    
    setSelectedPopularMenu
      ({
        label: items?.itemName,
        value: items?.itemName,
      });
    

    setMenuFoodItemModal(true);
    setIsview(true);
    setIsedit(false);
    setFormIsValid(false);
    setErrors({});
  };

  const deletetoggle = (items) => {
    // console.log("items",items);
    setMenulistitem({
      itemDesc: items?.itemDesc,
      itemFoodImage: "",
      itemImagePath: items?.itemImagePath,
      uom: items?.uom,
      itemId: items?.itemId || "",
      itemName: items?.itemName,
      itemPrice: items?.itemPrice,
      itemQuantity: items?.itemQuantity,
      menuName: items?.mainMenuName,
      categoryName: items?.categoryName,
      subCategoryName: items?.subCategoryName,
      categoryId: items?.categoryId,
      subCategoryId: items?.subCategoryId,
      itemType: items?.itemType === "veg" ? true : false,
      outletCode: restarantvalue.value,
      status: "A",
    });
    setDeletepopup(true);
    setIsview(true);
    setIsedit(false);
    setFormIsValid(false);
  };

  const nestedLevelItemCheck = async (dayId, slotData) => {
    await setMenuAvailablityListSaveUpdateDeleteMaster(
      menuAvailablityListSaveUpdateDeleteMaster.map((items) => ({
        ...items,
        slotId: items.slotId.map((object1) =>
          items.dayId == dayId && object1.slotId == slotData?.slotId
            ? { ...object1, itemAvailablity: !slotData?.itemAvailablity }
            : object1
        ),
      }))
    );
  };

  const apiMasterCallOfmenuAvailablityListSaveUpdateDeleteMaster = async () => {
    // console.log("current", menuAvailablityListSaveUpdateDeleteMaster);
    // console.log("current", menuSubmenuItems);

    // setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
    //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   }),
    // );

    // let saveupdateMasterOFmenuAvailablityListSaveUpdateDeleteMaster =
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.filter((item) => item.itemAvailablity === true)
    //       .map((item) => {
    //         return item["slotId"];
    //       })
    //   }));

    // let filtetredsave =
    //   saveupdateMasterOFmenuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   });

    // let deleteMasterOFmenuAvailablityListSaveUpdateDeleteMaster =
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.filter((item) => item.itemAvailablity === false)
    //       .map((item) => {
    //         return item["slotId"];
    //       })
    //   }));

    // let filtetredupdate =
    //   deleteMasterOFmenuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   });

    // let savereqformenusubmenu = await saveofMenuAVL(filtetredsave);
    // let deletereqformenusubmenu = await deleteodmenuAVL(filtetredupdate);

    // console.log("finalupdate0001", menuAvailablityListSaveUpdateDeleteMaster);
    // console.log("finalupdate0002", filtetredsave);
    // console.log("finalupdate0003", filtetredupdate);

    swal("Success!", "Time Slots Updated", "success");
    setFoodItemTiming(!foodItemTiming);
  };

  const saveMenuSubmenu = async (key) => {
    let data = "";
    data = {
      outletCode: restarantvalue.value,
      status: "A",
      menuId: outletvalue?.value || "",
      menuName: menuSubmenuItems?.menuName || "",
      subMenuId: menuSubmenuItems?.subMenuId || "",
      subMenuName: menuSubmenuItems?.subMenuName || "",
    };
    let reqformenusubmenu;
    if (key === "Maninmenu") {
      reqformenusubmenu = await saveMainMenuName(data);
    } else if (key === "SubManinmenu") {
      reqformenusubmenu = await saveSubMenuName(data);
    } else {
    }

    if (reqformenusubmenu.data.status === true) {
      setMenuSubmenuItems({});
      setMainMenuModal(false);
      setSubMenuModal(false);
      setMenuFoodItemModal(false);
      setFoodItemTiming(false);
      getMenuMasterListMasterApi();
      setIsview(false);
      setIsedit(false);
      if (key === "Maninmenu") {
        swal("Success!", "Menu Created", "success");
      } else {
        swal("Success!", "Sub Menu Updated", "success");
      }
    } else {
      setMainMenuModal(!mainMenuModal);
      getMenuMasterListMasterApi();
      swal("Oops", "Error, Please Try Later", "error");
    }
  };

  const onChangeCommonpopup = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    if (key == "itemType") {
      addFieldValue = { [key]: value };
      setFormIsValid(formIsValidLocal);
    }

    if (key == "itemFoodImage") {
      const newFormData = { ...menulistitem };
      newFormData[key] = value.target.files[0];
      setMenulistitem(newFormData);
    } else {
      const newFormData = { ...menulistitem };
      newFormData[key] = value;
      setMenulistitem(newFormData);
    }

    // if (key == "topRecommendation") {
    //
    //    console.log("key", key)
    //    console.log("key", value)
    //   addFieldValue = { [key]: value };
    //   setFormIsValid(formIsValidLocal);
    // }
  };

  const blockInvalidChar = (e) => {
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  };

  const onChangeCommonpopupsetOutletvalue = (key, value) => {
    // console.log("key", key);
    // console.log("value", value);

    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    const stringPattern = /^[-a-zA-Z-()]+(\s+[-a-zA-Z()]+)*$/;
    const stringwithnumberPattern = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/;
    const mobilePattern = /^[5-9][0-9]{9}$/;
    const emailPattern =
      /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;

    if (key == "itemName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemName"] = "Item Name is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
      // else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["itemName"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      else {
        addFieldValue = { [key]: value };
        errorsLocal["itemName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "itemPrice") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemPrice"] = "Item Price is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringwithnumberPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["itemPrice"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["itemPrice"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "itemQuantity") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemQuantity"] = "Item Quanity is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringwithnumberPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["itemQuantity"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["itemQuantity"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "itemDesc") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemDesc"] = "Item Desc is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["itemDesc"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "itemTag") {
      // console.log("value.length", value.length);
      //console.log("value.length", value[0]);
      // console.log("value.length", selected);
      // let trimmedvalue = value && value[0].trim();

      if (value[0] == "") {
        return false;
      } else {
        // const arr = [" zero ", " one ", " two "];
        const trimmedItemTagArray = value && value.map((item) => item.trim());
        // console.log("trimmedItemTagArray", trimmedItemTagArray);
        let duplicateItemTagArray = [...new Set(trimmedItemTagArray)];
        //console.log("duplicateItemTagArray", duplicateItemTagArray);
        const tempstatemaster =
          duplicateItemTagArray &&
          duplicateItemTagArray
            .filter((item) => item != "")
            .map((item) => {
              return item && item.toLowerCase();
            });

        // console.log("tempstatemaster", tempstatemaster);
        setSelected(tempstatemaster || []);

        addFieldValue = { [key]: value };
        errorsLocal["itemTag"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "uom") {
      if (!value) {
        addFieldValue = { [value.label]: null };
        errorsLocal["uom"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        setSelecteduomMaster({
          label: value.label,
          value: value.value,
        });
        // addFieldValue = { ["role"]: value.value }
        errorsLocal["uom"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "planId") {
      if (!value) {
        addFieldValue = { [value.label]: null };
        errorsLocal["planId"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        setSelecteduomMaster({
          label: value.label,
          value: value.value,
        });
        addFieldValue = { ["planId"]: value.value };
        errorsLocal["planId"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "topRecommendation") {
      if (!value) {
        addFieldValue = { [value.checkbox]: null };
        errorsLocal["topRecommendation"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { ["topRecommendation"]: value };
        errorsLocal["topRecommendation"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    // console.log("addFieldValue", addFieldValue);
    const newFormData = { ...menulistitem };
    newFormData[key] = value;
    setMenulistitem(newFormData);
    // console.log("setMenulistitem", menulistitem)
  };

  /* const onChangeCommonpopupsetOutletvalue = (key, event) => {
     
     console.log("event", event);
     setAdditemSubmenuMaster([]);
    if (key == "mainmenuname") {
      setMenufetchitem({
        menuId: event.value,
        menuName: event.label,
        selectedMainmenuItem: event,
      });
      const tempstatemaster = menuMasterList
        .filter((item) => item.menuId == event.value)
        .map((item) => {
          return item.subMenu;
        });

      let additemSubmenuMasterresponse = tempstatemaster[0]?.map(
        ({ subMenuName, subMenuId }) => ({
          label: subMenuName,
          value: subMenuId,
        })
      );

      console.log("additemSubmenuMasterresponse", additemSubmenuMasterresponse);
      setAdditemSubmenuMaster(additemSubmenuMasterresponse);
    }

    if (key == "submainmenuname") {
       
       console.log("menuSubmenuItems?.menuId", menuSubmenuItems);

      setMenufetchitem({
        selectedSubmenuItem: event.label,
        subMenuId: event.value,
        subMenuName: event.label,

        menuId: menuSubmenuItems?.menuId,
        menuName: menuSubmenuItems?.menuName,
         menuName: event.label,
         selectedMainmenuItem: event
      });

      const tempstatemaster = menuMasterList
        .filter((item) => item.menuId == menuSubmenuItems?.menuId)
        .map((item) => {
          return item?.subMenu[0].subMenuItem;
        });

      console.log("tempstatemaster", tempstatemaster);

       let additemSubmenuMasterresponse = tempstatemaster && tempstatemaster.length > 0 && tempstatemaster?.map(({ itemName, itemId }) => ({
         label: itemName,
         value: itemId,
       }));
       console.log("additemSubmenuMasterresponse", additemSubmenuMasterresponse);
    }
  }; */

  /* function getSteps() {
    // return ["Add Item Details", "Variant Item & Add-Ons"];
    return ["Add Item Details"];
  } */

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <FoodMenuForm
            menulistitem={menulistitem}
            additemSubmenuMaster={additemSubmenuMaster}
            onChangeCommonpopup={onChangeCommonpopup}
            category={category}
            uomlist={uomlist}
            selecteduomMaster={selecteduomMaster}
            uomcategory={uomcategory}
            errors={errors}
            isView={isView}
            subscribeItemModalm={subscribeItemModalm}
            onChangeCommonpopupsetOutletvalue={
              onChangeCommonpopupsetOutletvalue
            }
            blockInvalidChar={blockInvalidChar}
          />
        );

      case 1:
        return <VariantItemForm variant={variant} />;
    }
  }

  const chkImgFile = (file) => {
    // console.log("file", file);
    if (file) {
      const fileArr = file.split(".");
      const fileExt = fileArr[fileArr.length - 1];
      if (fileExt.toLowerCase() == "pdf") {
        return false;
      } else {
        return true;
      }
    }
  };
  const skippedSteps = () => {
    return skipped.size;
  };
  const isStepOptional = (step) => {
    return step === 1 || step === 2;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleStep = (step) => {
    // console.log("step", step);
    setActiveStep(step);
  };
  /*  const totalSteps = () => {
    return getSteps().length;
  }; */
  const completedSteps = () => {
    return completed.size;
  };

  /* const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps() - skippedSteps();
  }; */

  const submitFoodItemApi = async () => {
    // console.log("menulistitem", menulistitem)
    // console.log(" menulistitem?.topRecommendation", menulistitem?.topRecommendation)

    let values =
      subscribeItemModalm === false
        ? selectedspecialMenu.value.split("-")
        : selectedPopularMenu.value.split("-");
    let id = values[0] || "";
    let name = values[1] || "";
    let price = values[2] || "";
     console.log("valuesdata", values);
    console.log("priceprice", price);

    // let plan = menulistitem.planId.split("-");
    // //console.log("planplan",plan);
    // let planId = plan[0]||0;
    // //console.log("planId",planId);
    // let planName = plan[1]||"";



    let data = "";
    data = {
      compCode: outletvalue.value,
      itemDesc: menulistitem?.itemDesc,
      // planId: planId || 0,
      // planname: planName || "",
      itemFoodImage: menulistitem?.itemFoodImage || "",
      itemId:  menulistitem.itemId || id,
      itemName:  menulistitem.itemName.label,
      itemPrice:  menulistitem.itemPrice||price,
      itemTag: selected && selected.toString(),
      itemQuantity: "1",
      itemType: menulistitem?.itemType === true ? "veg" : "nonveg",
      outletCode: restarantvalue.value,
      status: "A",
      uom: menulistitem?.uom || "",
      itemImagePath:
        menulistitem?.itemFoodImage == undefined
          ? menulistitem?.itemImagePath
          : "",
      varient: [
        // { large: "", medium: "",small: "",  varientId:"", varientType:  ""}
      ],
      //topRecommendation: menulistitem?.topRecommendation,
    };

    let formData = new FormData();

    for (var key in data) {
      if (Array.isArray(data[key])) {
        data[key].forEach((obj, index) => {
          let keyName = [key, "[", index, "]"].join("");
          formData.append("itemFoodImage", obj);
        });
      } else {
        var f = new File([""], "filename");
        if (key == "itemFoodImage" && data["itemFoodImage"] == "") {
          formData.append(key, f);
        } else {
          formData.append(key, data[key]);
        }
      }
    }

    let reqformenusubmenu;
    if (menulistitem?.itemId == undefined || menulistitem?.itemId == "") {
      reqformenusubmenu = await addOutletItem(formData);
    } else {
      reqformenusubmenu = await UpdateOutletItem(formData);
    }

    if (reqformenusubmenu.data.status === true) {
      if (menulistitem?.itemId == undefined || menulistitem?.itemId == "") {
        swal("Success!", "Item Added", "success");
      } else {
        swal("Success!", "Item Updated", "success");
      }
      setMenulistitem({});
      setMenuFoodItemModal(false);
      setFoodItemTiming(false);
      getmenulist(outletvalue.value, restarantvalue.value);
      setMainMenuModal(false);
      setSubMenuModal(false);
      setMenuFoodItemModal(!menuFoodItemModal);
      setIsview(false);
      setIsedit(false);
      setSelected([]);
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setMenuFoodItemModal(false);
      setFoodItemTiming(false);
      getmenulist(outletvalue.value, restarantvalue.value);
      setMainMenuModal(false);
      setSubMenuModal(false);
      setMenuFoodItemModal(!menuFoodItemModal);
      setIsview(false);
      setIsedit(false);
      setMenulistitem({});
      setSelected([]);
    }
  };

  const getMenuAvailalbitList = async () => {
    // console.log("menuSubmenuItems", menuSubmenuItems?.selectedMainmenuItem?.value)
    let outletCode =
      adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;
    let mainMenuId = menuSubmenuItems?.menuId;
    let subMenuId = menuSubmenuItems?.subMenuId;
    let menuId = menuSubmenuItems?.selectedIndividualFoodItem;
    let menuavailityList = await getMenuAvailalbitListApi(
      outletCode,
      mainMenuId,
      subMenuId,
      menuId
    );
    await setMenuAvailablityMaster(menuavailityList.data?.data);
    await setMenuSubmenuItems({
      mainMenuId: menuSubmenuItems?.menuId,
      subMenuId: menuSubmenuItems?.subMenuId,
      selectedIndividualFoodItem: menuSubmenuItems?.selectedIndividualFoodItem,
      selectedIndividualFoodItemName:
        menuSubmenuItems?.selectedIndividualFoodItemName,
    });
    // setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
    //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["slotId"] = enablebollean;
    //     return { ...obj };
    //   }),
    // );

    if (menuavailityList.data?.status === true) {
      setMenuAvailablityListSaveUpdateDeleteMaster(menuavailityList.data?.data);

      // await setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
      //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
      //     obj["slotId"] = menuavailityList.data?.data;
      //     return { ...obj };
      //   }),
      // );

      // await setMenuAvailablityListSaveUpdateDeleteMaster(
      //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
      //     ...items,
      //     slotId: items.slotId && items.slotId.filter(object1 => {
      //       return menuavailityList.data?.data.map(object2 => ({
      //         ...object2,
      //         slotTime: object2.slotTime.some(object3 => {
      //           object1["itemAvailablity"] = true;
      //           object1["itemAvailablity"] = false;
      //           return parseInt(object1.slotId) === parseInt(object3.slotId) ?
      //             { ...object1["itemAvailablity"] = true }
      //             :
      //             { ...object1["itemAvailablity"] = false }
      //         })
      //       }
      //       ));
      //     })
      //   })));
    } else {
      // setMenuAvailablityListSaveUpdateDeleteMaster(
      //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
      //     ...items,
      //     slotId: items.slotId.map(object1 => {
      //       return { ...object1, itemAvailablity: true }
      //     })
      //   })));

      await setMenuAvailablityListSaveUpdateDeleteMaster(
        (menuAvailablityListSaveUpdateDeleteMaster) =>
          menuAvailablityListSaveUpdateDeleteMaster.map((obj) => {
            obj["slotId"] = [];
            return { ...obj };
          })
      );
    }
    await setFoodItemTiming(true);
  };

  const deleteitem = async (key) => {
    let compCode = outletvalue.value;
    let outletCode = restarantvalue.value;
    let menuId = menulistitem.itemId || "";

    let reqformenusubmenu;
    if (key === "Deletemenu") {
      reqformenusubmenu = await deletemenuitem(compCode, outletCode, menuId);
    } else {
    }

    if (reqformenusubmenu.data.status === true) {
      setMenulistitem({});
      setDeletepopup(false);
      getmenulist(outletvalue.value, restarantvalue.value);
      setIsview(false);
      setIsedit(false);
      if (key === "Deletemenu") {
        swal("Success!", "Menu Item Deleted", "success");
      }
    } else {
      getmenulist(outletvalue.value, restarantvalue.value);
      setDeletepopup(false);
      swal("Oops", `${reqformenusubmenu.data.message}`, "error");
    }
  };

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  const onClose = () => {
    setMainMenuModal(!mainMenuModal);
  };

  const CloseImage = () => {
    setOpenImagePopup(!openImagePopup);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const renderItem = ({ item, collapseIcon, handler }) => {
    return (
      <div>
        {handler}
        {collapseIcon}
        {item.mainmenu}
      </div>
    );
  };

  const stylescheck = () => {
    let maxWidth = "";
    if (menuFoodItemModal) {
      return maxWidth == "500px";
    } else if (subMenuModal) {
      return maxWidth == "700px";
    } else {
    }
  };
  

  let actionOption = {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (summary, tableMeta, updateValue) => {
        return (
          <div className="list-action">
            <span
              style={{ color: "white", display: "flex" }}
              className="icon-top-left"
            >
              

              <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  itemtoggle(tableMeta);
                }}
              >
                <i
                  className="fas fa-pencil-alt fa-lg tpen-bck"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "1px",
                  }}
                ></i>
              </Link>

              <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  deletetoggle(tableMeta);
                }}
                // style={{ background: "#008000" }}
              >
                <i
                  className="ti-trash  tpen-bck"
                  style={{ marginLeft: "3px" }}
                ></i>
              </Link> 
            </span>

           
          </div>
        );
      },
    },
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };

  const columns = [
    {
      name: "itemName",
      label: "Item Name",
      options: {
        filter: true,
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
      },
    },

    {
      name: "itemPrice",
      label: "Item Price",
      options: {
        filter: false,
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "itemType",
      label: "Item Type",
      options: {
        filter: true, // Enable filter for Restaurant
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
      },
    },

    {
      name: "itemQuantity",
      label: "Item Qty ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "uomName",
      label: "Uom Name ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "itemTag",
      label: "Item Tag ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "itemDesc",
      label: "Item Details ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "planId",
      label: "Plan ID ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    actionOption,
  ];
  const options = {
    filter: true, // Enable global search
    search: true, // Disable individual column search (to avoid redundancy)
    selectableRows: false,
    responsive: "stacked",
    fixedHeader: true,
    tableBodyHeight: "51vh",
    fixedSelectColumn: true,
    page: currentPage,
    pagination: true,
    serverSide: false,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    onChangePage: (newPage) => {
      handleChangePage(newPage);
    },
    onChangeRowsPerPage: (numOfRows) => {
      onChangeRowsPerPage(numOfRows);
    },
    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterOptions,
      changedColumnIndex
    ) => {
      // Handle filter change here
      // You can update state or perform any other action based on the new filterList
    },
    confirmFilters: true,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => applyNewFilters()} // Call applyNewFilters to apply filters
          >
            Apply Filters
          </Button>
        </div>
      );
    },
    onFilterConfirm: (filterList) => {
    },
    onFilterDialogOpen: () => {
    },
    onFilterDialogClose: () => {
    },
    customToolbar: () => {
      return (
        <>
         
        </>
      );
    },
  };
  


  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });


  return (
    <>
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 temp-crd">
          <Card>
            <div class="row ovrl-crd-hd">
              <div class="col-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <h3 className="me-auto main-hd">Menu</h3>
                </div>
              </div>
              <div class="col-8 col-md-8 col-lg-8 row" style={{marginTop:"3px"}}>
                <Card.Header
                  className="card-title  main-card temp-hd-obj"
                  // style={{ marginLeft: "26%" }}
                >
                  <div
                    class="col-4 col-md-4 col-lg-4 form-group main-frm-grp"
                    // style={{ width: "30%" }}
                  >
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Company
                    </label>
                    <Select
                      options={companyMaster}
                      value={outletvalue}
                      closeMenuOnSelect={false}
                      search
                      name="stateCode"
                      placeholder="Choose"
                      autoComplete="off"
                      onChange={(event) => {
                        setMenufetchitem([]);
                        setRestarantvalue({ label: "", value: "" });
                        setOutletvalue(event);
                        getoutletMasterList(event?.value);
                        getoutletMasterList();
                      }}
                    />
                  </div>

                  <div
                    class="col-4 col-md-4 col-lg-4 form-group main-frm-grp"
                    style={{ zIndex:"800"}}
                  >
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Restaurant
                    </label>
                    <Select
                      options={outletMasterlist}
                      value={restarantvalue}
                      closeMenuOnSelect={false}
                      search
                      name="stateCode"
                      placeholder="Choose"
                      autoComplete="off"
                      onChange={(event) => {
                        setRestarantvalue(event);
                        // console.log("event", event);
                        getmenulist(outletvalue?.value, event?.value);
                        getRestarantmenulist(event);
                        getSubscrptionList(event?.value);
                        getRestarantPopularlist(event?.restaurantId);
                      }}
                    />
                  </div>

                  <div
                    class=" col-2 col-md-2 col-lg-2 mt-3  form-group"
                    style={{ display: "contents" }}
                  >
                    {restarantvalue.value && (
                      <>
                        {/* <i
                          className="fa fa-download mt-4"
                          onClick={saveExcel}
                          // disabled={restarantvalue.value == ""}
                          style={{ marginRight: "13px", color: "green" }}
                        ></i> */}
                        <Button
                          className=""
                          variant="success dark btn-sm"
                          // disabled={restarantvalue.value == ""}
                          style={{
                            backgroundColor: "#0f590f",
                            borderRadius: "5px",
                            border: "0px solid",
                            height: "36px",
                           marginTop:"27px",
                          }}
                          onClick={() => {
                            getoutletList();
                          }}
                        >
                          <i
                            class="fas fa-plus"
                            onClick={() => {
                              getoutletList();
                            }}
                          >
                            Add Item{" "}
                          </i>{" "}
                        </Button>
                      </>
                    )}
                  </div>
                  <div
                    class="col-2 col-md-2 col-lg-2 form-group main-frm-grp"
                    // style={{ width: "10%" }}
                  >
                    {restarantvalue.value && (
                      <>
                        {/* <i
                          className="fa fa-download mt-4"
                          onClick={saveExcel}
                          // disabled={restarantvalue.value == ""}
                          style={{ marginRight: "13px", color: "green" }}
                        ></i> */}
                        <Button
                          className=""
                          variant="success dark btn-sm"
                          // disabled={restarantvalue.value == ""}
                          style={{
                            backgroundColor: "#1976d2",
                            borderRadius: "5px",
                            border: "0px solid",
                            height: "36px",
                            marginTop:"27px",
                          }}
                          onClick={() => {
                            getSubscriptionList();
                          }}
                        >
                          <i
                            class="fas fa-plus"
                            onClick={() => {
                              getSubscriptionList();
                            }}
                          >
                            Subscription Item{" "}
                          </i>{" "}
                        </Button>
                      </>
                    )}
                  </div>
                </Card.Header>
              </div>
            </div>
            <Card.Body
              className="scroll-tbl-fix-header tab-hd-clr"
              style={{ padding: "3px" }}
            >
              <div class="inp-srch">
                {" "}
                <input
                  type="text"
                  placeholder="Search Menu item/tag"
                  style={{
                    marginBottom: "14px",
                    marginLeft: "400px",
                    border: "1px solid ",
                    borderRadius: "",
                    padding: "5px",
                  }}
                  onChange={(e) => {
                    searchFilterMenuListMaster(e.target.value);
                  }}
                />
              </div>
              <RctCollapsibleCard fullBlock>
              <RctCollapsibleCard fullBlock>
                <MuiThemeProvider theme={themeTable}>
                  <MUIDataTable
                    title={""}
                    data={menufetchitem}
                    columns={columns}
                    options={options}
                    columOrder={columns}
                    className={"MuiTabCusCls"}
                  />
                </MuiThemeProvider>
              </RctCollapsibleCard>
            </RctCollapsibleCard>
            {/* <Table responsive stripped>
                <br />
                <thead>
                  <tr>
                    <th>
                      <strong>ITEM NAME</strong>
                    </th>
                    <th>
                      <strong>ITEM PRICE</strong>
                    </th>

                    <th>
                      <strong>ITEM TYPE</strong>
                    </th>

                    <th>
                      <strong>ITEM QTY</strong>
                    </th>

                    <th>
                      <strong>UOM</strong>
                    </th>

                    <th>
                      <strong>ITEM TAG</strong>
                    </th>

                    <th>
                      <strong>IMAGE</strong>
                    </th>

                    <th>
                      <strong>ITEM DETAIL</strong>
                    </th>

                    <th>
                      <strong>ACTIONS</strong>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {menufetchitem &&
                    menufetchitem.map((items) => {
                      return (
                        <>
                          <tr>
                            <td>{items.itemName}</td>
                            <td>{items.itemPrice}</td>
                            <td>
                              {items.itemType == "veg" ? (
                                <Badge variant="success light">
                                  {items.itemType}
                                </Badge>
                              ) : (
                                <Badge variant="warning light">
                                  {items.itemType}
                                </Badge>
                              )}
                            </td>
                            <td>{items.itemQuantity}</td>
                            <td>{items.uomName}</td>
                            {/* <td>{items.itemTag}</td> */}

                            {/* <td> */}
                              {/* { items.itemTag  selected.map((items) => (                            
                           <Badge key={items.itemTag} label={items.itemTag}  />
               ))} */}
                              {/* <Badge variant="success dark">
                                {items.itemTag}
                              </Badge>
                            </td>

                            <td>
                              <img
                                src={items.itemImagePath}
                                onClick={() => {
                                  setOpenImagePopup(!openImagePopup);
                                  setTempModalPopupValue(items.itemImagePath);
                                }}
                                width="50%"
                                height="50%"
                                target="blank"
                                style={{ width: "30px" }}
                              ></img>
                            </td>
                            <td>{items.itemDesc}</td>

                            <td>
                              <i
                                onClick={() => {
                                  itemtoggle(items);
                                  //       console.log("items",items);
                                }}
                                style={{ fontSize: "large" }}
                                className="ti-pencil  tpen-bck"
                              ></i>

                              <i
                                onClick={() => {
                                  deletetoggle(items);
                                  setDeletepopup(true);
                                }}
                                style={{
                                  fontSize: "large",
                                  marginLeft:"3px",
                                }}
                                className="ti-trash  tpen-bck"
                              ></i>
                            </td>
                          </tr>
                        </>
                      );
                    })}

                  {menufetchitem && menufetchitem.length <= 0 && (
                    <div style={{ color: "red" }}> No Data Found </div>
                  )}
                </tbody>
              </Table> */}
            </Card.Body>
          </Card>
        </div>
      </div>

      <Modal
        isOpen={
          // mainMenuModal ||
          subMenuModal || menuFoodItemModal || foodItemTiming || deletepopup
        }
        toggle={() => onClose()}
        style={{
          display:"block",
          margin:"80px auto",
          maxWidth:
            (menuFoodItemModal && "800px") ||
            (subMenuModal && "700px") ||
            (foodItemTiming && "1200px"),
        }}
        backdrop="static"
      >
        <div className="cstm-mdl-hd cstm-mdl-hd-btn">
        <ModalHeader>
          {
            /* {(mainMenuModal && "Add Main Menu") || */
            (subMenuModal && "Add Sub Menu") ||
              (deletepopup && " Delete Item") ||
              (menuFoodItemModal &&
              (menulistitem?.status == undefined || menulistitem?.status == "")
                ? `Add Itemccc ${restarantvalue.label}`
                : `Update Item -  ${restarantvalue.label} - ${menulistitem?.itemName} `)
          }

          {foodItemTiming && (
            <>
              <br />
              <div className="row">
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <Select
                    // IsMulti={true}
                    options={dropdownMaster}
                    // options={outletRolelist.filter((item) => {
                    //   return item.label != "ADMIN";
                    // })}
                    // search
                    // value={dropdownMastervalue}
                    value={dropdownMastervalue}
                    name="stateCode"
                    placeholder="Choose"
                    onChange={(event) => dropdownHandling("type", event)}
                  />
                </div>

                {/* {dropdownMastervalue.value == "2" && */}
                <div className="col-sm-6 col-md-3 col-xl-3">
                  <Select
                    // IsMulti={true}
                    options={dropdownMasterDay}
                    // options={outletRolelist.filter((item) => {
                    //   return item.label != "ADMIN";
                    // })}
                    search
                    // isDisabled={dropdownMastervalue?.value != "2"}
                    // disabled={dropdownMastervalue?.value != "2"}
                    // value={staffvalue}
                    name="stateCode"
                    placeholder="Day"
                    // onChange={(event) =>
                    //   dropdownHandling("type", event)
                    // }
                  />
                </div>

                {/* } */}

                <div className="col-sm-6 col-md-3 col-xl-3">
                  {/* <Select
                    options={dropdownslotmaster}
                    search
                    name="stateCode"
                    placeholder="Slot"
                  /> */}
                  <Multiselect
                    options={dropdownslotmaster}
                    // selectedValues={selectedValueRegion}
                    // onSelect={this.handleRegion}
                    // onRemove={this.handleRemoveRegion}
                    showCheckbox={true}
                    closeOnSelect={false}
                    displayValue="label"
                  />
                </div>
                <div className="col-sm-6 col-md-3 col-xl-3">
                  <Button
                    variant="primary"
                    // style={{ marginLeft: "352px" }}
                    onClick={() => {
                      apiMasterCallOfmenuAvailablityListSaveUpdateDeleteMaster();
                      // setFoodItemTiming(!foodItemTiming);
                      // console.log("current", menuAvailablityListSaveUpdateDeleteMaster);
                    }}
                  >
                    Update Slot
                  </Button>
                </div>
              </div>

              {/* <label style={{ paddingLeft: "290px" }}>
                <input type="checkbox"
                  checked={checkeditem}
                  onChange={() => {
                    alldayallsotBoolean();
                  }}
                />
                All Day All Slot  {checkeditem}
              </label> */}

              {/* const [checkeditem, setCheckeditem] = useState(false); */}
            </>
          )}
        </ModalHeader>
        <ModalBody>
          {deletepopup && (
            <>
              <span>
                Are you sure want to delete item ?{" "}
                <strong>{menulistitem?.itemName}</strong>
              </span>
            </>
          )}

          {/* {mainMenuModal && (
            <div className="row">
              <div className="col-sm-8 col-md-8 col-xl-8">
                <FormGroup>
                  <Label for="menu">
                    Main Menu Name
                    <span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="menu"
                    id="menu"
                    placeholder="Enter  Menu"
                    maxLength="40"
                    required
                    autoComplete="off"
                    onChange={(e) => {
                      //
                      setMenuSubmenuItems({
                        menuName: e.target.value,
                      });
                    }}
                  />
                </FormGroup>
              </div>
            </div>
          )} */}
          {subMenuModal && (
            <div className="row">
              <div className="col-sm-6 col-md-6 col-xl-5">
                <FormGroup>
                  <Label for="itemqty">
                    Menu Name<span class="text-danger">*</span>
                  </Label>
                  <Select
                    options={category}
                    search
                    name="stateCode"
                    placeholder="Choose Menu"
                    autoComplete="off"
                    value={outletvalue}
                    onChange={(event) => {
                      setOutletvalue({
                        label: event.label,
                        value: event.value,
                      });
                    }}
                  />
                </FormGroup>
              </div>
              <div className="col-sm-6 col-md-6 col-xl-5">
                <FormGroup>
                  <Label for="submenu">
                    Sub Menu
                    <span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="submenu"
                    id="submenu"
                    placeholder="Enter Sub Menu"
                    maxLength="40"
                    required
                    autoComplete="off"
                    onChange={(e) => {
                      //
                      setMenuSubmenuItems({
                        subMenuName: e.target.value,
                      });
                    }}
                  />
                </FormGroup>
              </div>
            </div>
          )}
          {menuFoodItemModal && (
            <>
              <FoodMenuForm
                menulistitem={menulistitem}
                additemSubmenuMaster={additemSubmenuMaster}
                onChangeCommonpopup={onChangeCommonpopup}
                category={category}
                uomlist={uomlist}
                uomcategory={uomcategory}
                selected={selected}
                selecteduomMaster={selecteduomMaster}
                subscribeItemModalm={subscribeItemModalm}
                errors={errors}
                isView={isView}
                onChangeCommonpopupsetOutletvalue={
                  onChangeCommonpopupsetOutletvalue
                }
                blockInvalidChar={blockInvalidChar}
                specialmenulist={specialmenulist}
                popularmenu={popularmenu}
                setSelectedSpecialMenu={setSelectedSpecialMenu}
                setSelectedPopularMenu={setSelectedPopularMenu}
                selectedplanId={selectedplanId}
              />
            </>
          )}

          {/*  {openImagePopup && (
            <>
              {tempModalPopupValue != "" ? (
                <>
                  {chkImgFile(tempModalPopupValue) ? (
                    <>
                      <a href={tempModalPopupValue} download target="_blank">
                        Download Image
                      </a>

                      <br />
                      <ReactPanZoom image={tempModalPopupValue} alt="image" />
                    </>
                  ) : (
                    <iframe
                      src={tempModalPopupValue}
                      width="100%"
                      height="400px"
                    ></iframe>
                  )}
                </>
              ) : (
                <p>File Not Available</p>
              )}
            </>
          )} */}

          {foodItemTiming && (
            <div className="row">
              {menuAvailablityListSaveUpdateDeleteMaster &&
                menuAvailablityListSaveUpdateDeleteMaster.map((items) => {
                  return (
                    <Col xl="4">
                      <Card className="text-white  times-card">
                        <CardTitle className="text-white bg-secondary">
                          {items.dayName}
                          {/* <label style={{ paddingLeft: "150px" }}>
                          <input type="checkbox"
                            checked={checkeditem}
                          />{""}
                          Day Slot
                        </label> */}
                        </CardTitle>
                        <CardBody>
                          {items?.slotTime &&
                            items?.slotTime.map((data) => {
                              //
                              // console.log("data", data);
                              return (
                                <>
                                  {/* {data?.itemAvailablity === true && */}
                                  <div>
                                    <h4>
                                      {data.slotName} :
                                      <span className="badge badge-lg bg-green time-chip mr-2">
                                        {data.startTime} - {data.endTime}
                                      </span>
                                      {/* <label style={{ paddingLeft: "12px" }}>
                                    <input type="checkbox"
                                      checked={data?.itemAvailablity === true}
                                      onChange={() => { nestedLevelItemCheck(items?.dayId, data) }}
                                    />
                                  </label> */}
                                    </h4>
                                  </div>
                                  {/* } */}
                                </>
                              );
                            })}
                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}
            </div>
          )}
        </ModalBody>

        <ModalFooter>
          {deletepopup && (
            <>
              <Button
                variant="success"
                onClick={() => {
                  deleteitem("Deletemenu");
                }}
              >
                Delete
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  setDeletepopup(false);
                }}
              >
                Cancel
              </Button>
            </>
          )}
          {/* {mainMenuModal && (
            <>
              <Button
                variant="primary"
                // disabled={menuSubmenuItems?.menuName == ""}
                onClick={() => {
                  saveMenuSubmenu("Maninmenu");
                }}
              >
                Save
              </Button>

              <Button
                variant="danger light"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  //  setSubMenuModal(false),
                  // setMainMenuModal(false);

                  setMainMenuModal(false);
                  setSubMenuModal(false);
                  setMenuFoodItemModal(false);
                  setOpenImagePopup(false);
                }}
              >
                Close
              </Button>
            </>
          )} */}

          {subMenuModal && (
            <>
              <Button
                variant="primary"
                // disabled={menuSubmenuItems?.subMenuName == ""}
                onClick={() => {
                  saveMenuSubmenu("SubManinmenu");
                }}
              >
                Save
              </Button>
              <Button
                variant="danger light"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  // setSubMenuModal(false);
                  // setMainMenuModal(false)

                  setMainMenuModal(false);
                  setSubMenuModal(false);
                  setMenuFoodItemModal(false);
                  setOpenImagePopup(false);
                }}
              >
                Close
              </Button>
            </>
          )}

          {menuFoodItemModal && (
            <>
              {isView === false && isedit === false && (
                <Button
                  variant="primary"
                  disabled={
                    menulistitem.itemFoodImage == "" ||
                    (selected && selected.length == 0)
                  }
                  /* className={!formIsValid ? "btn-disabled" : "btn-primary"} */
                  onClick={() => {
                    submitFoodItemApi();
                    //  console.log("submitFoodItemApi", submitFoodItemApi);
                  }}
                >
                  Submit
                </Button>
              )}
              {isView === true && isedit === false && (
                <Button
                  variant="contained"
                  // className={!formIsValid ? "btn-disabled" : "btn-primary"}
                  className={"btn-primary"}
                  onClick={() => {
                    submitFoodItemApi();
                  }}
                  // disabled={!formIsValid}
                >
                  Update
                </Button>
              )}

              <Button
                variant="secondary"
                onClick={() => {
                  // setMainMenuModal(false);
                  //setSubMenuModal(false);
                  setMenuFoodItemModal(false);
                  // setOpenImagePopup(false);
                  setErrors({});
                  setIsview(false);
                  setIsedit(false);
                  setSelecteduomMaster({});
                  setSelected([]);
                }}
              >
                Cancel
              </Button>
            </>
          )}

          {foodItemTiming && (
            <>
              <Button
                variant="danger light"
                onClick={() => {
                  setFoodItemTiming(false);
                  setMainMenuModal(false);
                  setSubMenuModal(false);
                  setMenuFoodItemModal(false);
                  setOpenImagePopup(false);

                }}
              >
                Cancel
              </Button>
            </>
          )}
        </ModalFooter>
        </div>
      </Modal>
      <Modal
        isOpen={openImagePopup}
        toggle={() => CloseImage()}
        style={{ maxWidth: "800px" }}
        backdrop="static"
      >
        <ModalHeader>
          <>
            {tempModalPopupValue != "" ? (
              <>
                {chkImgFile(tempModalPopupValue) ? (
                  <>
                    <a href={tempModalPopupValue} download target="_blank">
                      Download Image
                    </a>
                    <i
                      className="ti-close"
                      onClick={CloseImage}
                      style={{
                        paddingTop: "10px",
                        paddingLeft: "599px",
                        color: "black",
                        fontSize: "medium",
                      }}
                    ></i>
                    <br />
                    <ReactPanZoom image={tempModalPopupValue} alt="image" />
                  </>
                ) : (
                  <iframe
                    src={tempModalPopupValue}
                    width="100%"
                    height="100px"
                  ></iframe>
                )}
              </>
            ) : (
              <p>File Not Available</p>
            )}
          </>
        </ModalHeader>
      </Modal>
      <Modal
        isOpen={togglemodal}
        toggle={() => onToggleClose()}
        size={"lg"}
        style={{ maxWidth: "800px" }}
        backdrop="static"
      >
        <ModalHeader onClick={onToggleClose}>
          Category / Sub Category Update
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-sm-6 col-md-4 col-xl-4">
              <FormGroup>
                <Label for="itemqty">Main Category</Label>
                <Select
                  options={menu}
                  search
                  placeholder="Choose Menu"
                  autoComplete="off"
                />
              </FormGroup>
            </div>
            <div className="col-sm-6 col-md-4 col-xl-4">
              <FormGroup>
                <Label for="itemqty">
                  Sub Category <span class="text-danger">*</span>
                </Label>
                <Select
                  options={submenu}
                  search
                  placeholder="Choose SubMenu"
                  autoComplete="off"
                />
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="me-2"
            variant="success"
            onClick={() => onToggleClose(false)}
          >
            Submit
          </Button>
          <Button variant="danger" onClick={() => onToggleClose(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default OutletFoodMenuListManagment;
